import React, { useState, useEffect, useMemo } from 'react';
import { FlatList, ScrollView, SectionList, TouchableOpacity, View } from 'react-native'

import api from "../../../../../utils/api"
import tw from '../../../../../styles/tailwind';
import Text from '../../../../../components/Text';
import Icon from '../../../../../components/IcomoonIcon';
import { Image } from 'expo-image';
import { useQuery } from '@tanstack/react-query';
import Header from '../../../../../navigation/Header';
import dayjs from 'dayjs';
import useUnitsSearch from '../../../../../hooks/useUnitsSearch';
import SearchInput from '../../../../../components/SearchInput';
import { useNavigation } from '@react-navigation/native';
import useOpenDetailParam from '../../../../../hooks/useOpenDetailParam';




export default function UnitsFeesSection({ communityId  }) {

  const { isLoading, error, data: units, refetch: refetchUnits } = useQuery({
    queryKey: ['community.units', communityId],
    queryFn: () => api.get(`/communities/${communityId}/units`).then(response => response.data),
  })

  const [searchQuery, setSearchQuery] = useState("");
  const { filteredUnits, isSearching } = useUnitsSearch({ communityId, searchQuery })

  // Calles colapsadas por defecto.
  const [expandedStreets, setExpandedStreets] = useState({})
  function toggleStreet(street) {
    setExpandedStreets(prev => ({ ...prev, [street]: !prev[street] }))
  }

  // Agrupar viviendas por calle (street_name).
  const streetGroups = useMemo(() => {
    const groups = {}
    filteredUnits?.forEach(u => {
      const street = u.street_name || 'Sin calle'
      if (!groups[street]) groups[street] = []
      groups[street].push(u)
    })
    return Object.keys(groups).sort().map(street => ({ street, units: groups[street] }))
  }, [filteredUnits])

  // Filas del listado: planas al buscar; acordeón por calle cuando no hay búsqueda.
  const listData = useMemo(() => {
    if (isSearching) {
      return (filteredUnits || []).map(u => ({ type: 'unit', unit: u, key: u.uuid }))
    }
    const rows = []
    streetGroups.forEach(({ street, units }) => {
      rows.push({ type: 'street', street, count: units.length, key: `street:${street}` })
      if (expandedStreets[street]) {
        units.forEach(u => rows.push({ type: 'unit', unit: u, key: u.uuid }))
      }
    })
    return rows
  }, [isSearching, filteredUnits, streetGroups, expandedStreets])

  const navigation = useNavigation()
  const openUnitId = useOpenDetailParam(navigation, 'Admin.Units.Fees.Balance', 'unitId')

  function goToUnitFeeDetails(unit) {
    navigation.navigate("Admin.Units.Fees.Balance", {
      communityId,
      unitId: unit.uuid,
    })
  }


  return (
    <View style={tw`flex-1 bg-white`}>
      <View style={tw`bg-secondary px-4 pb-4 rounded-b-2xl mb-3`}>
        <SearchInput style={{ container: tw`mt-5` }} onChange={setSearchQuery} />
      </View>

        {
          isLoading &&
          <Text style={tw`text-gray-400 text-center mt-4 mb-4`}>Cargando...</Text>
        }

        <FlatList
          data={listData}
          extraData={openUnitId}
          contentContainerStyle={tw`pb-16`}
          ListHeaderComponent={
            isSearching ? (
              <View style={tw`bg-gray-100 px-4 py-2 row justify-between`}>
                <Text style={tw`text-gray-400`}>Calle</Text>

                <View style={tw`row`}>
                  <Text style={tw`text-gray-400`}>#ext</Text>
                </View>
              </View>
            ) : null
          }
          renderItem={({ item, index }) => {
            // Encabezado de calle (acordeón)
            if (item.type === 'street') {
              const expanded = !!expandedStreets[item.street]
              return (
                <TouchableOpacity
                  style={tw`row justify-between px-4 h-13 bg-gray-100 border-b border-gray-200`}
                  onPress={() => toggleStreet(item.street)}
                >
                  <Text style={tw`text-secondary font-600`}>{item.street}</Text>

                  <View style={tw`row items-center`}>
                    <Text style={tw`text-gray-400 mr-3`}>{item.count} casas</Text>
                    <Icon
                      name='chevron-right'
                      size={11}
                      color={tw.color('secondary')}
                      style={{ transform: [{ rotate: expanded ? '90deg' : '0deg' }] }}
                    />
                  </View>
                </TouchableOpacity>
              )
            }

            // Fila de vivienda
            const unit = item.unit
            return (
              <TouchableOpacity
                style={tw.style(
                  `row justify-between px-4 h-15 border-b border-gray-100`,
                  !isSearching && `pl-8`,
                  unit.uuid === openUnitId && `bg-selected border border-selected-border rounded-xl`
                )}
                onPress={() => goToUnitFeeDetails(unit)}
              >
                <View style={tw``}>
                  <View style={tw`row`}>
                    <Text style={tw`text-secondary`}>{unit.name}</Text>
                    {
                      unit.street_name_2 &&
                      <Text style={tw`text-gray-400 ml-2`}>{unit.street_name_2}</Text>
                    }
                  </View>

                  {
                    unit.owners?.length > 0 &&
                    <Text style={tw`text-gray-400`}>{unit.owners[0].name}</Text>
                  }
                </View>

                <View style={tw``}>
                  <Text>{unit.external_number}</Text>
                </View>
              </TouchableOpacity>
            )
          }}
          keyExtractor={item => item.key}
        />

        {
          filteredUnits?.length === 0 &&
          <Text style={tw`text-gray-400 text-center mt-8`}>Sin viviendas registradas</Text>
        }
    </View>
  )
}
